import { useContext, useEffect, useState } from 'react';
import Modal from '../Modal';
import TextInput from '../TextInput';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import { setCalendarIntegrationsQuery } from '../../lib/Queries';
import * as Toast from '../../lib/Toast.js';
import { ErrorContext } from '../../lib/ErrorContext';

const ICloudConnectModal = ({ isModalShowing, onClose }) => {
    const [appleid, setAppleid] = useState('');
    const [password, setPassword] = useState('');

    const { save, isSaving } = useBusinessPostApi(
        `/integrations/calendars/icloud`,
        { noToast: true },
    );

    useEffect(() => {
        if (isModalShowing) {
            setAppleid('');
            setPassword('');
        }
    }, [isModalShowing]);

    function submit(ev) {
        ev.preventDefault();
        save({
            appleid: appleid,
            password: password,
        }).then(result => {
            onClose();
            setCalendarIntegrationsQuery(result);
            Toast.success(
                'Successfully connected calendar. Please do not revoke the app specific password in Apple, that will disconnect syncing.',
            );
        });
    }

    return (
        <Modal isOpen={isModalShowing} onClose={onClose}>
            <form onSubmit={submit}>
                <TextInput
                    label="Apple ID"
                    id="appleid"
                    value={appleid}
                    onChange={setAppleid}
                />

                <TextInput
                    label="Password"
                    id="password"
                    value={password}
                    onChange={setPassword}
                    className="mt-4"
                />
                <div className="text-sm">
                    Please{' '}
                    <a
                        href="https://support.apple.com/en-us/HT204397"
                        target="_blank"
                    >
                        create an app specific password
                    </a>{' '}
                    to connect, you cannot use your normal iCloud password. The
                    password will be in the form <em>xxxx-xxxx-xxxx-xxxx</em>.
                </div>

                <button className="btn-save mt-4">
                    {isSaving ? 'Saving...' : 'Save'}
                </button>
            </form>
        </Modal>
    );
};

export default ICloudConnectModal;
